// ==============================================================================
// Imports
// ==============================================================================
import axios from 'axios';
import Config from "../../config.json";
// ==============================================================================
// API calls
// ==============================================================================
const baseAPIURI = Config.baseAPIURI
// we are setting value for portal API to empty string since hGDC portal is not going to be used anymore
const portalAPIURI = "";

const exports = {

// NEW DJANGO API COMPONENTS
    generateKYBTypeCountryCoverageReport: (type, authToken) => {
        return axios.get(`${baseAPIURI}/reports/country-coverage-kyb/${type}`,{
            headers: {
                Authorization: "Bearer " + authToken,
                Accept: "application/xlsx; charset=utf-8",
            },
            responseType: "blob"
        })
    },
// ==============================================================================
// Methods for billing-organizations CRUD operations
// ==============================================================================
    getOneBillingOrg: (authToken, orgID) => {
        return axios.get(`${baseAPIURI}/billing/organizations/${orgID}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    getAllBillingOrganizations: (authToken) => {
        return axios.get(`${baseAPIURI}/billing/organizations/`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    postBillingOrg: (authToken, billingOrgObj) => {
        return axios.post(`${baseAPIURI}/billing/organizations/`, billingOrgObj, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    putBillingOrg: (authToken, orgID, billingOrgObj) => {
        return axios.put(`${baseAPIURI}/billing/organizations/${orgID}`, billingOrgObj, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    deleteBillingOrg: (authToken, orgID) => {
        return axios.delete(`${baseAPIURI}/billing/organizations/${orgID}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    getAssociatedServiceIds: (authToken, tenantName) => {
        return axios.get(`${baseAPIURI}/billing/organizations/tenant/services/${tenantName}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    createNewUserForCP: (authToken, portalPayload) => {
        return axios.post(`${baseAPIURI}/billing/portal/user/create`, portalPayload, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    postResetPasswordRequest: (email) => {
        return axios.post(`${portalAPIURI}/auth/users/reset_password/`,
            {email}
        );
    },
// ==============================================================================
// Methods for Tenant Pricing Tables CRUD operations
// ==============================================================================

    getAllPricingTablesV2: (authToken) => {
        return axios.get(`${baseAPIURI}/billing/v2/pricing-tables/`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },

    getOnePricingTableV2: (authToken, pricingID) => {
        return axios.get(`${baseAPIURI}/billing/v2/pricing-tables/${pricingID}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    getCountryPricingRecordsV2: (authToken, pricingID) => {
        return axios.get(`${baseAPIURI}/billing/v2/country-pricing/${pricingID}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    postCountryPricingV2: (authToken, countryPricingObjectV2) => {
        return axios.post(`${baseAPIURI}/billing/v2/country-pricing/`, countryPricingObjectV2, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    putCountryPricingV2: (authToken, countryPricingID, countryPricingObject) => {
        return axios.put(`${baseAPIURI}/billing/v2/country-pricing/${countryPricingID}`, countryPricingObject, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    deleteCountryPricingV2: (authToken, countryPricingID) => {
        return axios.delete(`${baseAPIURI}/billing/v2/country-pricing/${countryPricingID}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    postPricingTableV2: (authToken, pricingTableObjV2) => {
        return axios.post(`${baseAPIURI}/billing/v2/pricing-tables/`, pricingTableObjV2, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    putPricingTableV2: (authToken, pricingID, pricingTableObjV2) => {
        return axios.put(`${baseAPIURI}/billing/v2/pricing-tables/${pricingID}`, pricingTableObjV2, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    deletePricingTableV2: (authToken, pricingID) => {
        return axios.delete(`${baseAPIURI}/billing/v2/pricing-tables/${pricingID}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    postUploadPricingData: (authToken, file) => {
        const formData = new FormData();
        formData.append('file', file);

        return axios.post(`${baseAPIURI}/billing/upload-pricing-data`, formData, {
            headers: {
                Authorization: "Bearer " + authToken,
                'Content-Type': 'multipart/form-data'
            }
        });
    },


// ==============================================================================
// Methods for KYC testcache CRUD operations (updated from /testcache/db to /testcache/kyc)
// ==============================================================================
    getKYCTestcacheAll: (authToken) => {
        return axios.get(`${baseAPIURI}/testcache/kyc/`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    postKYCTestcacheRecord: (authToken, testcacheObject) => {
        return axios.post(`${baseAPIURI}/testcache/kyc/`, testcacheObject, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    putKYCTestcacheRecord: (authToken, testcacheObject, testcacheGUID) => {
        return axios.put(`${baseAPIURI}/testcache/kyc/${testcacheGUID}`, testcacheObject, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    deleteKYCTestcacheRecord: (authToken, testcacheGUID) => {
        return axios.delete(`${baseAPIURI}/testcache/kyc/${testcacheGUID}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    generateTestcacheCSVReport: (recordIdsObject, authToken) => {
        return axios.post(`${baseAPIURI}/reports/testcache/csv/`, recordIdsObject,{
            headers: {
                Authorization: "Bearer " + authToken,
                Accept: "text/csv; charset=utf-8",
            },
            responseType: "blob"
        })
    },
    generateKYBTestcacheCSVReport: (recordIdsObject, authToken) => {
        return axios.post(`${baseAPIURI}/reports/testcache/kyb/csv/`, recordIdsObject, {
            headers: {
                Authorization: "Bearer " + authToken,
                Accept: "text/csv; charset=utf-8",
            },
            responseType: "blob"
        })
    },

// ==============================================================================
// Methods for KYB testcache CRUD operations (new endpoint)
// ==============================================================================
    getKYBTestcacheAll: (authToken) => {
        return axios.get(`${baseAPIURI}/testcache/kyb/`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    postKYBTestcacheRecord: (authToken, kybTestcacheObject) => {
        return axios.post(`${baseAPIURI}/testcache/kyb/`, kybTestcacheObject, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    putKYBTestcacheRecord: (authToken, kybTestcacheObject, kybTestcacheId) => {
        return axios.put(`${baseAPIURI}/testcache/kyb/${kybTestcacheId}`, kybTestcacheObject, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    deleteKYBTestcacheRecord: (authToken, kybTestcacheId) => {
        return axios.delete(`${baseAPIURI}/testcache/kyb/${kybTestcacheId}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
// ==============================================================================
// Methods for getting and setting data providers
// ==============================================================================
    getAllOrganizations: (authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/v2/data-providers`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    getOneDataProvider: (dpID, authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/v2/data-providers/${dpID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    postDataProvider: (dpObj, authToken) => {
        return axios.post(`${baseAPIURI}/veritas/api/v2/data-providers`, dpObj,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    updateDataProvider: (dpID, dpObj, authToken) => {
        return axios.put(`${baseAPIURI}/veritas/api/v2/data-providers/${dpID}`, dpObj,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    deleteDataProvider: (dpID, authToken) => {
        return axios.delete(`${baseAPIURI}/veritas/api/v2/data-providers/${dpID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
// ==============================================================================
// Methods for getting and setting Countries
// ==============================================================================
    getCountries: (authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/v2/countries`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    getOneCountry: (countryID, authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/v2/countries/${countryID}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    putOneCountry: (countryID, countryObj, authToken) => {
        return axios.put(`${baseAPIURI}/veritas/api/v2/countries/${countryID}`, countryObj, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    postOneCountry: (countryObj, authToken) => {
        return axios.post(`${baseAPIURI}/veritas/api/v2/countries`, countryObj, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    deleteOneCountry: (countryID, authToken) => {
        return axios.delete(`${baseAPIURI}/veritas/api/v2/countries/${countryID}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },

// ==============================================================================
// Methods for getting and setting DP Services
// ==============================================================================

    getAllDPServices: (authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/all-services`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    getAllKYCServices: (authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/v2/kyc-services`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    getAllKYBServices: (authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/v2/kyb-services`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    getDPServiceByID: (serviceID, authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/v2/kyc-services/${serviceID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    getKYBServiceByID: (serviceID, authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/v2/kyb-services/${serviceID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    postDPService: (dpServiceObj, authToken) => {
        return axios.post(`${baseAPIURI}/veritas/api/v2/kyc-services`, dpServiceObj,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    postKYBDPService: (dpServiceObj, authToken) => {
        return axios.post(`${baseAPIURI}/veritas/api/v2/kyb-services`, dpServiceObj,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    updateDPService: (dpServiceID, dpServiceObj, authToken) => {
        return axios.put(`${baseAPIURI}/veritas/api/v2/kyc-services/${dpServiceID}`, dpServiceObj,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    updateKYBDPService: (dpServiceID, dpServiceObj, authToken) => {
        return axios.put(`${baseAPIURI}/veritas/api/v2/kyb-services/${dpServiceID}`, dpServiceObj,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    deleteDPService: (serviceID, authToken) => {
        return axios.delete(`${baseAPIURI}/veritas/api/v2/kyc-services/${serviceID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    deleteKYBDPService: (serviceID, authToken) => {
        return axios.delete(`${baseAPIURI}/veritas/api/v2/kyb-services/${serviceID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    getSupportingSelections: (authToken) => {
      return axios.get(`${baseAPIURI}/veritas/api/supportingselections`, {
          headers: {
              Authorization: "Bearer " + authToken
          }
      });
    },
    logStatusChange: (statusLogObj, authToken) => {
        return axios.post(`${baseAPIURI}/veritas/api/dpservice/logstatus`, statusLogObj,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    generateAssociatedTenantsWithOneServiceReport: (serviceType, serviceID, selectedCountry, authToken) => {
        return axios.get(`${baseAPIURI}/reports/service/all-tenants/xlsx/${serviceType}/${serviceID}/${selectedCountry}`,{
            headers: {
                Authorization: "Bearer " + authToken,
                Accept: "application/xlsx; charset=utf-8",
            },
            responseType: "blob"
        })
    },
    getCountriesSourcesForTenants: (tenantIds, comparisonTenantId, authToken) => {
        return axios.post(`${baseAPIURI}/reports/tenant-countries-sources`, { tenants: tenantIds, comparisonTenantId: comparisonTenantId }, {
            headers: {
                Authorization: "Bearer " + authToken,
                Accept: "application/xlsx; charset=utf-8",
            },
            responseType: "blob"
        })
    },
    getPricingDataForTenants: (tenantIds, authToken) => {
        return axios.post(`${baseAPIURI}/reports/tenant-pricing-data`, { tenants: tenantIds }, {
            headers: {
                Authorization: "Bearer " + authToken,
                Accept: "application/xlsx; charset=utf-8",
            },
            responseType: "blob"
        })
    },
    getOrgTenantsAndCountriesWithId: (authToken) => {
        return axios.get(`${baseAPIURI}/billing/organizations/org-tenant-id-info`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        }) 
    },
    postServiceConfigName: (scnObject, authToken) => {
        return axios.post(`${baseAPIURI}/veritas/api/v2/service-config`, scnObject,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    copyServiceConfigName: (transferObject, authToken) => {
        return axios.put(`${baseAPIURI}/copy-service/`, transferObject, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },

// ==============================================================================
// Methods for getting and creating DP Sources and setting report data
// ==============================================================================
    getDPSourcesByServiceID: (serviceID, authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/dpsource/dpservice/${serviceID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    getDPSourceByID: (sourceID, authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/v2/kyc-sources/${sourceID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    getKYBSourceByID: (sourceID, authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/v2/kyb-sources/${sourceID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    postDPSource: (dataObj, authToken) => {
        return axios.post(`${baseAPIURI}/veritas/api/v2/kyc-sources`, dataObj,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    postKYBDPSource: (dataObj, authToken) => {
        return axios.post(`${baseAPIURI}/veritas/api/v2/kyb-sources`, dataObj,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    updateDPSource: (sourceID, dpSourceObj, authToken) => {
        return axios.put(`${baseAPIURI}/veritas/api/v2/kyc-sources/${sourceID}`, dpSourceObj,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    updateKYBDPSource: (sourceID, dpSourceObj, authToken) => {
        return axios.put(`${baseAPIURI}/veritas/api/v2/kyb-sources/${sourceID}`, dpSourceObj,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    deleteDPSource: (sourceID, authToken) => {
        return axios.delete(`${baseAPIURI}/veritas/api/v2/kyc-sources/${sourceID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    deleteKYBDPSource: (sourceID, authToken) => {
        return axios.delete(`${baseAPIURI}/veritas/api/v2/kyb-sources/${sourceID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    getSourceIDsWithServiceIDs: (IDs, authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/dpsource/serviceids/${IDs}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    getSourcesForKYCPDFReport: (formatted_payload, authToken) => {
        return axios.post(`${baseAPIURI}/reports/kyc/pdf`, formatted_payload, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    getSourcesForPDFOneTenant: (request_payload, authToken) => {
        return axios.post(`${baseAPIURI}/reports/tenants/pdf`, request_payload, {
            headers: {
                Authorization: "Bearer " + authToken,
            },
        });
    },
    getSourcesForKYBPDFReport: (formatted_payload, authToken) => {
        return axios.post(`${baseAPIURI}/reports/kyb/pdf`, formatted_payload,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    getSourcesForKYCXLSReport: (reportType, formatted_payload, authToken) => {
        return axios.post(`${baseAPIURI}/reports/${reportType}/kyc/xlsx`, formatted_payload, {
            headers: {
                Authorization: "Bearer " + authToken,
                Accept: "application/xlsx; charset=utf-8",
            },
            responseType: "blob"
        });
    },
    getSourcesForXLSOneTenant: (reportType, request_payload, authToken) => {
        return axios.post(`${baseAPIURI}/reports/${reportType}/tenants/xlsx`, request_payload, {
            headers: {
                Authorization: "Bearer " + authToken,
                Accept: "application/xlsx; charset=utf-8",
            },
            responseType: "blob"
        });
    },
    getSourcesForKYBXLSReport: (reportType, formatted_payload, authToken) => {
        return axios.post(`${baseAPIURI}/reports/${reportType}/kyb/xlsx`,formatted_payload, {
            headers: {
                Authorization: "Bearer " + authToken,
                Accept: "application/xlsx; charset=utf-8",
            },
            responseType: "blob"
        });
    },
// ==============================================================================
// Methods for creating DocLinks
// ==============================================================================
    postDocLink: (docObj, authToken) => {
        return axios.post(`${baseAPIURI}/veritas/api/doclinks`, docObj,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
// ==============================================================================
// Methods for creating Pricing Matrix
// ==============================================================================
    postPricingMatrix: (pricingMatrixObj, authToken) => {
        return axios.post(`${baseAPIURI}/veritas/api/dppricing`, pricingMatrixObj,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },

// ==============================================================================
// Methods for DP Service status options
// ==============================================================================
    getDPStatusOptions: (authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/dpstatus`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    getStatusByID: (statusID, authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/dpstatus/${statusID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },

// ==============================================================================
// Methods for getting DP Source Type Options
// ==============================================================================
    getSourceTypes: (authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/dpsourcetypes`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    getSourceTypeByID: (sourceTypeID, authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/dpsourcetypes/${sourceTypeID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },

// ==============================================================================
// Methods for getting DP Input Field Options
// ==============================================================================
    getDPInputFields: (authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/dpsourceinputs`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },

// ==============================================================================
// Methods for logging & getting user changes
// ==============================================================================
    postChange: (logObj, authToken) => {
        return axios.post(`${baseAPIURI}/veritas/api/changelog`, logObj,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    getChangeLog: (itemType, itemID, authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/changelog/${itemType}/${itemID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },

// ==============================================================================
// Methods for getting and setting page approvals
// ==============================================================================
    getApprovalData: (pageType, pageID, authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/approvals/getdata/${pageType}/${pageID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    clearApprovalData: (approvalObject, authToken) => {
        return axios.put(`${baseAPIURI}/veritas/api/approvals/`, approvalObject,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    setApproval: (approvalObject, authToken) => {
        return axios.put(`${baseAPIURI}/veritas/api/approvals/`, approvalObject,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    getUnapprovedDPs: (authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/approvals/dataproviders`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    getUnapprovedDPServices: (authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/approvals/dpservices`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    getUnapprovedDPSources: (authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/approvals/dpsources`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },

// ==============================================================================
// Methods for getting User Microsoft Graph Details
// ==============================================================================
    getUserMSDetails: (token, authToken) => {
        return axios.post(`${baseAPIURI}/veritas/api/user`, token, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },


// ==============================================================================
// Methods for getting Support Page Debug Files and Transaction Logs
// ==============================================================================

    getDebugFiles: (authToken, wsid) => {
        return axios.get(`${baseAPIURI}/support/debug/${wsid}`, {
            headers: {
                Authorization: "Bearer " + authToken
            },
        });
    },

    getTransactionLogs: (authToken, wsid) => {
        return axios.get(`${baseAPIURI}/support/txlog/${wsid}`, {
            headers: {
                Authorization: "Bearer " + authToken
            },
        });
    },

// ==============================================================================
// Methods for Billing Group CRUD operations
// ==============================================================================
    getAllBillingGroups: (authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/v2/billing-groups`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    getOneBillingGroup: (bgID, authToken) => {
        return axios.get(`${baseAPIURI}/veritas/api/v2/billing-groups/${bgID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    putOneBillingGroup: (bgID, bgObject, authToken) => {
        return axios.put(`${baseAPIURI}/veritas/api/v2/billing-groups/${bgID}`, bgObject, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    postOneBillingGroup: (bgObject, authToken) => {
        return axios.post(`${baseAPIURI}/veritas/api/v2/billing-groups`, bgObject, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    updateBillingGroup: (bgID, bgObject, authToken) => {
        return axios.put(`${baseAPIURI}/veritas/api/v2/billing-groups/${bgID}`, bgObject,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    deleteOneBillingGroup: (bgID, authToken) => {
        return axios.delete(`${baseAPIURI}/veritas/api/v2/billing-groups/${bgID}`,{
            headers: {
                Authorization: "Bearer " + authToken
            }
        });
    },
    getBGPricingScheme: (authToken, bgID) => {
        return axios.get(`${baseAPIURI}/veritas/api/v2/billing-groups-country-pricing/${bgID}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    postBGPricingScheme: (authToken, bgPricingObject) => {
        return axios.post(`${baseAPIURI}/veritas/api/v2/billing-groups-country-pricing`, bgPricingObject, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    putBGPricingScheme: (authToken, countryPricingID, bgPricingObject) => {
        return axios.put(`${baseAPIURI}/veritas/api/v2/billing-groups-country-pricing/${countryPricingID}`, bgPricingObject, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    deleteBGCountryPricing: (authToken, countryPricingID) => {
        return axios.delete(`${baseAPIURI}/veritas/api/v2/billing-groups-country-pricing/${countryPricingID}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
// ==================================================
// Methods for Manual Entry Billing Records CRUD Ops
// ==================================================
    getBillingRecords: (selectedRange, authToken) => {
        return axios.get(`${baseAPIURI}/billing/manual-entry-records/${selectedRange}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    getOrgTenantsAndCountries: (authToken) => {
        return axios.get(`${baseAPIURI}/billing/manual-entry-records/org-tenant-info`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    postOneBillingRecord: (billingRecordObject, authToken) => {
        return axios.post(`${baseAPIURI}/billing/manual-entry-records`, billingRecordObject, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    putOneBillingRecord: (billingRecordObject, recordID, authToken) => {
        return axios.put(`${baseAPIURI}/billing/manual-entry-records/${recordID}`, billingRecordObject, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    deleteOneBillingRecord: (recordID, authToken) => {
        return axios.delete(`${baseAPIURI}/billing/manual-entry-records/${recordID}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },

// ==================================================
// Methods for Billing Reports
// ==================================================
    postUpdateLinks: (authToken) => {
      return axios.post(`${baseAPIURI}/billing/rollup/update-links`, {},{
          headers: {
              Authorization: "Bearer " + authToken,
          },
      })
    },
    postMonthlyRollup: (date, authToken) => {
        return axios.post(`${baseAPIURI}/billing/rollup/monthly/${date}`, {}, {
            headers: {
                Authorization: "Bearer " + authToken,
            },
        })
    },
    getBillingReport: (date, authToken) => {
        return axios.get(`${baseAPIURI}/billing/reports/gdc/${date}`, {
            headers: {
                Authorization: "Bearer " + authToken,
            },
        })
    },
    postBillingReport: (date, authToken) => {
        return axios.post(`${baseAPIURI}/billing/reports/gdc/${date}`, {},{
            headers: {
                Authorization: "Bearer " + authToken,
            },
        })
    },
    postRunPricing: (date, authToken) => {
        return axios.post(`${baseAPIURI}/billing/pricing/run/${date}`, {},{
            headers: {
                Authorization: "Bearer " + authToken,
            },
        })
    },
    getSapInputFile: (date, entropy, authToken) => {
        return axios.get(`${baseAPIURI}/billing/reports/sap/input-file/${date}?entropy=${entropy}`, {
            headers: {
                Authorization: "Bearer " + authToken,
            },
        })
    },
    getSapUsageControlFile: (date, entropy, authToken) => {
        return axios.get(`${baseAPIURI}/billing/reports/sap/usage-control/${date}?entropy=${entropy}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    getEntropyString: (authToken) => {
        return axios.get(`${baseAPIURI}/billing/reports/sap/entropy`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
    getSapUploadStatus: (date, authToken) => {
        return axios.get(`${baseAPIURI}/billing/reports/sap/status/${date}`, {
            headers: {
                Authorization: "Bearer " + authToken
            }
        })
    },
};

export default exports;